import Track from 'core/logger/track';
import * as actions from '../models/actions/names';

class WordCounterTrack {
  clickedCopyButton = (text: string, triggeredBy = 'copyAll') => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_COPY_BUTTON, { triggeredBy });
  };

  clickedDeleteButton = () => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_DELETE_TEXT);
  };

  userPastedText = (text: string, numberOfWords: number) => {
    Track.getInstance().ampEvent(actions.USER_PASTED_TEXT, {
      numberOfWords,
      numberOfCharacters: text?.trim()?.length,
    });
  };
}

const wordCounterTrack = new WordCounterTrack();
export default wordCounterTrack;
